import ENV from '@/constants/env';

export const IS_DEVELOPMENT = ENV.NODE_ENV === 'development';

export const IS_PRODUCTION = ENV.NODE_ENV === 'production';
